import Vue from "vue";
import { Action } from "vuex-class";
import { Component } from "vue-property-decorator";

@Component({})
export default class ResetPassword extends Vue {
  @Action action_putResetPassword: any;

  password_confirmation = "";
  password = "";
  isLoadBtn = false;

  token = "";
  email = "";

  mounted() {
    this.token = this.$route.params.token;
    this.email = this.$route.query.email as any;

    if (!this.token || !this.email) {
      this.$router.push({ name: "root" });
    }
  }

  async _reset() {
    try {
      // @ts-ignore
      this.$ga.event("Reset", "Login", "password");
      this.isLoadBtn = true;

      const data = {
        user: {
          password: this.password,
          password_confirmation: this.password_confirmation,
        },
      };

      await this.action_putResetPassword({
        token: this.token,
        email: this.email,
        data,
      });
      this.isLoadBtn = false;
      const result = await this.$swal({
        title: "Cuenta recuperada!",
        text: "Ya puedes iniciar sesión",
        confirmButtonText: "Cool",
      });
      if (result) {
        this.$router.push({ name: "login" });
      }
    } catch (error) {
      // revismos si llego un error por el usuario
      this.isLoadBtn = false;
      const status = error && error.response && error.response.status;
      if (status >= 500) {
        this.$swal({
          title: "Error al intentar entrar por email.",
          text: `Problemas con el servidor. Error ${status}`,
        });
      } else {
        this.$swal({
          title: "Error al intentar entrar por email.",
          text: error.response.data.message,
        });
      }
    }
  }
}
